/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, ref } from '@vue/composition-api';
import dropdownItemProps from './dropdown-item-props.js';
import { useTNodeJSX } from '../hooks/tnode.js';
import { usePrefixClass } from '../hooks/useConfig.js';
import { pxCompat } from '../utils/helper.js';
import Ripple from '../utils/ripple.js';
import { getKeepAnimationMixins } from '../config-provider/config-receiver.js';
import 'lodash/isEmpty';
import 'lodash/isFunction';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../hooks/render-tnode.js';
import 'lodash/isString';
import 'lodash/isObject';
import '../config-provider/useConfig.js';
import '../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import '../_common/js/utils/set-style.js';
import '../config.js';
import 'vue';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var keepAnimationMixins = getKeepAnimationMixins();
var _DropdownItem = defineComponent({
  name: "TDropdownItem",
  mixins: [keepAnimationMixins],
  directives: {
    ripple: Ripple
  },
  props: _objectSpread(_objectSpread({}, dropdownItemProps), {}, {
    maxColumnWidth: {
      type: [String, Number],
      "default": 100
    },
    minColumnWidth: {
      type: [String, Number],
      "default": 10
    },
    isSubmenu: Boolean
  }),
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var itemRef = ref();
    var dropdownItemClass = usePrefixClass("dropdown__item");
    var handleItemClick = function handleItemClick(e) {
      var _props$onClick;
      (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, props.value, {
        e: e
      });
      emit("click", props.value, {
        e: e
      });
    };
    return {
      itemRef: itemRef,
      dropdownItemClass: dropdownItemClass,
      handleItemClick: handleItemClick
    };
  },
  render: function render() {
    var _ref2;
    var h = arguments[0];
    var classes = [this.dropdownItemClass, "".concat(this.dropdownItemClass, "--theme-").concat(this.theme), (_ref2 = {}, _defineProperty(_ref2, "".concat(this.dropdownItemClass, "--active"), this.active), _defineProperty(_ref2, "".concat(this.dropdownItemClass, "--disabled"), this.disabled), _ref2)];
    var renderTNodeJSX = useTNodeJSX();
    var prefixIcon = renderTNodeJSX("prefixIcon");
    return h("li", {
      "class": classes,
      "on": {
        "click": this.handleItemClick
      },
      "style": {
        maxWidth: pxCompat(this.maxColumnWidth),
        minWidth: pxCompat(this.minColumnWidth)
      },
      "directives": [{
        name: "ripple",
        value: !this.isSubmenu && this.keepAnimation.ripple
      }],
      "ref": this.itemRef
    }, [this.prefixIcon ? h("div", {
      "class": "".concat(this.dropdownItemClass, "-icon")
    }, [prefixIcon]) : null, renderTNodeJSX("default")]);
  }
});

export { _DropdownItem as default };
//# sourceMappingURL=dropdown-item.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/dropdown/dropdown-item.js
// module id = null
// module chunks = 